/**
 * Created by Ding on 12/04/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Button } from 'antd';

import { ajaxGet } from '../../utils/ajax';


export default class Candidate extends Component {

    static propTypes = {
        params: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        candidate: {},
        stages: [],
        recruiterName: '',
    };

    componentDidMount() {
        this.getCandidate();
        this.getStages();
    }

    getCandidate = () => {
        ajaxGet(`/recruit/api/hunter/findApplyInfoDetail/${this.props.params.candidateId}`, {}, (rawData) => {
            this.setState({
                candidate: rawData.data,
            });
            document.title = rawData.data.name;
        });
    };

    getStages = () => {
        ajaxGet(`/recruit/api/hunter/progressDetail/${this.props.params.candidateId}`, {}, (rawData) => {
            this.setState({
                stages: rawData.data.candidateStageList,
                recruiterName: rawData.data.recruiterName,
            });
        });
    };

    stages = {
        HR_SCREENING: '简历评估',
        DEP_SCREENING: '用人部门评估',
        INTERVIEWING: '面试',
        OFFER: 'Offer沟通',
        HIRE: '录用环节',
    };

    statuses = {
        IN_PROGRESS: '进行中',
        WAIT: '待安排',
        PASS: '本轮通过',
        FAIL: '本轮淘汰',
    };

    columns = [
        { name: '候选人姓名', key: 'name' },
        { name: '候选人手机号', key: 'phone' },
        { name: '候选人邮箱', key: 'email' },
        { name: '简历附件', key: 'downloadUrl' },
    ];

    render() {
        return (
            <div>
                <p className="detail-page-title">招聘进程</p>
                <div
                    style={{
                        padding: '24px',
                        marginBottom: '40px',
                        backgroundColor: '#eceff1',
                        position: 'relative',
                        height: '135px',
                        overflow: 'auto',
                    }}
                >
                    <div
                        style={{
                            height: '4px',
                            backgroundColor: 'white',
                            position: 'absolute',
                            top: '52px',
                            left: '25px',
                            width: 'calc(100% - 48px)',
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: this.state.stages ? `${this.state.stages.length * 166}px` : 0,
                                height: '100%',
                                backgroundColor: '#fc9153',
                                boxShadow: '0 2px 4px 0 rgba(252, 145, 82, 0.70)',
                            }}
                        />
                    </div>

                    <ul
                        style={{
                            height: '100%',
                            width: this.state.stages ? `${this.state.stages.length * 166}px` : 'auto',
                        }}
                    >
                        {this.state.stages && this.state.stages.map(item => (
                            <li
                                key={item.id.toString()}
                                style={{
                                    display: 'inline-block',
                                    verticalAlign: 'top',
                                    height: '100%',
                                    position: 'relative',
                                    width: '166px',
                                }}
                            >
                                <div style={{ margin: '0 auto', width: '130px' }}>
                                    <p style={{ color: '#999', lineHeight: '1' }}>{item.createTime.slice(0, 10)}</p>
                                    <p style={{ marginTop: '30px' }}>
                                        {`${this.stages[item.stage]}(${this.statuses[item.status]})`}
                                    </p>
                                    <p>
                                        <span>职位负责人：</span>
                                        <span>{this.state.recruiterName}</span>
                                    </p>
                                </div>

                                <div
                                    style={{
                                        width: '13px',
                                        height: '13px',
                                        borderRadius: '13px',
                                        position: 'absolute',
                                        top: '23px',
                                        right: 0,
                                        backgroundColor: '#fc9153',
                                        boxShadow: '0 2px 4px 0 rgba(252, 145, 82, 0.70)',
                                    }}
                                />
                            </li>
                        ))}
                    </ul>

                    <div
                        style={{
                            width: '13px',
                            height: '13px',
                            borderRadius: '13px',
                            position: 'absolute',
                            top: '47px',
                            left: '24px',
                            backgroundColor: '#fc9153',
                            boxShadow: '0 2px 4px 0 rgba(252, 145, 82, 0.70)',
                        }}
                    />
                </div>

                <p className="detail-page-title">个人信息</p>
                <div className="panel">
                    {this.columns.map((item, itemKey) => (
                        <p
                            key={item.key}
                            style={{
                                marginBottom: itemKey === this.columns.length - 1 ? 0 : '20px',
                            }}
                        >
                            <span style={{ display: 'inline-block', width: '80px', textAlign: 'right' }}>
                                {item.name}:
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                {item.key === 'downloadUrl' ?
                                    <a href={this.state.candidate.downloadUrl}>简历</a> :
                                    this.state.candidate[item.key]
                            }
                            </span>
                        </p>
                    ))}
                </div>

                <p className="detail-page-title">推荐人评价</p>
                <div className="panel">
                    {this.state.candidate.recommenderComment ?
                        this.state.candidate.recommenderComment.split(/\r\n|\n|\r/)
                        .map(line => <p key={Math.random()}>{line}</p>,
                    ) : ''}
                </div>

                <div style={{ textAlign: 'center' }}>
                    <Button onClick={() => this.props.history.goBack()}>返回</Button>
                </div>
            </div>
        );
    }
}
